import { useTranslation } from 'next-i18next'
import Flow from 'blocks/Flow'
import type { FlowProps } from 'blocks/Flow'

export function FlowSection() {
  const { t } = useTranslation('home.page')

  const data: FlowProps = {
    title: t('home-flow-title'),
    flowItems: [
      {
        id: 1,
        title: t('home-flow-item1-title'),
        description: t('home-flow-item1-description'),
        iconName: 'search',
      },
      {
        id: 2,
        title: t('home-flow-item2-title'),
        description: t('home-flow-item2-description'),
        iconName: 'check-round',
      },
      {
        id: 3,
        title: t('home-flow-item3-title'),
        description: t('home-flow-item3-description'),
        iconName: 'heart',
      },
      {
        id: 4,
        title: t('home-flow-item4-title'),
        description: t('home-flow-item4-description'),
        iconName: 'link',
      },
    ],
    bannerTitle: t('home-flow-banner-title'),
    bannerCTA: {
      title: t('home-flow-banner-cta-title'),
      url: '/loyalty',
      locale: false,
    },
  }

  return <Flow {...data} />
}
